export enum PageSize {
  Minimum = 2,
  Few = 5,
  Some = 10,
  Many = 20,
  Most = 50,
}
